<template>
  <div class="payment-success">
    <div class="payment-header">
      <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 91 104" fill="currentColor">
        <path
            d="M87.71 24.5805L48.2 1.77055C46.42 0.740547 44.2 0.740547 42.41 1.77055L2.9 24.5805C1.11 25.6105 0 27.5305 0 29.6005V75.2206C0 77.2806 1.11 79.2005 2.9 80.2405L42.41 103.051C43.29 103.561 44.29 103.821 45.31 103.821C46.33 103.821 47.33 103.551 48.21 103.051L87.72 80.2405C89.51 79.2105 90.62 77.2906 90.62 75.2206V29.6005C90.62 27.5405 89.51 25.6205 87.72 24.5805H87.71ZM46.2 49.5805C45.65 49.9005 44.96 49.9005 44.41 49.5805L6 27.4105L44.41 5.24055C44.95 4.93055 45.66 4.93055 46.2 5.24055L84.61 27.4105L46.2 49.5805V49.5805ZM42.41 53.0405C42.69 53.2005 42.99 53.3405 43.31 53.4505V98.9305L4.9 76.7705C4.35 76.4505 4 75.8606 4 75.2206V30.8705L42.41 53.0405V53.0405Z"
            fill="currentColor"></path>
      </svg>
      <div class="payment-status">
        <div class="status-icon">
          <span class="success-icon">✔</span>
        </div>
        <div class="status-text">
          <p class="status-title">付款已付</p>
          <p class="status-subtitle">您已成功支付发票</p>
        </div>
      </div>
    </div>
    <div class="payment-amount">
      <h1 class="amount-value">29.93 USDT</h1>
      <button class="copy-button">
        <span class="copy-icon">⎘</span>
      </button>
    </div>
    <div class="amount-usd">
      <p>29.95 USD</p>
      <p>网络· TRON</p>
    </div>
    <div class="payment-actions">
      <button class="action-button">🎁</button>
      <button class="action-button">❓</button>
      <button class="action-button">⚙</button>
    </div>
    <div class="tx-info">
      <label for="tx-id" class="tx-label">TxID</label>
      <div class="tx-value">
        <input type="text" id="tx-id" class="tx-id-input" value="8eba726c46c85fdeac1fbd2efb978d024f5a..." readonly />
        <button class="copy-tx-button">
          <span class="copy-icon">⎘</span>
        </button>
      </div>
    </div>
    <button class="back-button">退出</button>
  </div>
</template>

<script>
export default {
  name: "paySuccess"
}
</script>

<style scoped>
.payment-success {
  background-color: #f9f9f9;
  border-radius: 12px;
  padding: 24px;
  text-align: center;
}
.logo {
  width: 50px;
  height: auto;
  margin-bottom: 16px;
}
.payment-status {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 16px;
}
.status-icon {
  background-color: #d4edda;
  border-radius: 50%;
  padding: 12px;
}
.success-icon {
  color: #28a745;
  font-size: 24px;
}
.status-title {
  font-size: 18px;
  font-weight: bold;
}
.status-subtitle {
  color: #6c757d;
  font-size: 14px;
}
.payment-amount {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 24px 0;
}
.amount-value {
  font-size: 36px;
  font-weight: bold;
}
.copy-button {
  background: transparent;
  border: none;
  cursor: pointer;
}
.amount-usd {
  color: #6c757d;
  font-size: 14px;
  margin-bottom: 24px;
}
.payment-actions {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-bottom: 24px;
}
.action-button {
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 50%;
  padding: 10px;
  cursor: pointer;
  transition: background-color 0.3s;
}
.action-button:hover {
  background-color: #f0f0f0;
}
.tx-info {
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.tx-label {
  font-weight: bold;
}
.tx-value {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-grow: 1;
}
.tx-id-input {
  border: none;
  background: transparent;
  font-size: 14px;
  width: 100%;
  color: #333;
}
.copy-tx-button {
  background: transparent;
  border: none;
  cursor: pointer;
}
.back-button {
  background-color: #000000;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}
.back-button:hover {
  background-color: #333333;
}
</style>
